module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IvsA4D/images/coverpage.jpg?1705766126503",
      "alt": "This image is the cover for the book Type VII U-Boats"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Type VII U-Boats\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The ShipCraft series provides in-depth information about building and modifying model kits of famous warship types. Lavishly illustrated, each book takes the modeller through a brief history of the subject class, highlighting differences between sister-ships and changes in their appearance over their careers. This includes paint schemes and camouflage, featuring colour profiles and highly-detailed line drawings and scale plans. The modelling section reviews the strengths and weaknesses of available kits, lists commercial accessory sets for super-detailing of the ships, and provides hints on modifying and improving the basic kit. This is followed by an extensive photographic gallery of selected high-quality models in a variety of scales, and the book concludes with a section on research references  books, monographs, large-scale plans and websites.This volume is devoted to the largest class of submarines ever built, the Type VII, which formed the backbone of the German effort in the critical Battle of the Atlantic. A pre-war design, the Type VII was developed as the campaign progressed and was still in frontline service in 1945. All the major variants, as well as minor changes to equipment, are covered here. With its unparalleled level of visual information  paint schemes, models, line drawings and photographs  it is simply the best reference for any modelmaker setting out to build one of these famous boats.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Roger Chesneau\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Seaforth Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0